// extracted by mini-css-extract-plugin
export default {"headerBar":"nM-z","pointsSection":"oM-z","goToDashboard":"pM-z"};